import { useCallback } from "react";
import { getCurrentPlant } from "../../util/ApiOptionsHelper";
import { getColumnsWithGroup } from "../../api/Windows";
import { useWorkOrderStore } from "../../store/wo-order";

export default function useGetLaborLogFields() {
  const setWoLaborLogFields = useWorkOrderStore(
    (state) => state.setWoLaborLogFields
  );

  const createRequestData = useCallback(async () => {
    return {
      IncludeValidValues: "false",
      IncludeValidValuesExceptions: [],
      IsReadOnly: "true",
      ValidValueFilters: [],
      WindowName: "mob_wo_labor",
      ContextPKey: {
        Plant: await getCurrentPlant(),
        WoBase: "",
        WoTask: "  ",
        WoSubtask: "  ",
      },
    };
  }, []);

  const getLaborLogFields = useCallback(
    async (woNumber: string) => {
      const data = await createRequestData();
      const response = await getColumnsWithGroup(data);
      if (!response.isError) {
        let data = response.data;
        if (data.fields && Object.keys(data.fields).length > 0) {
          let fields = [] as any[];
          const keys = Object.keys(data.fields);
          keys.forEach((key) => {
            if (
              key.includes("wo_log_labor.") &&
              key !== "wo_log_labor.wo_base"
            ) {
              fields.push(data.fields[key]);
            }
          });
          fields.sort((a, b) => {
            return Number(a.FieldOrder) - Number(b.FieldOrder);
          });
          setWoLaborLogFields(woNumber, fields);
        }
      }
      return response;
    },
    [createRequestData, setWoLaborLogFields]
  );

  return { getLaborLogFields };
}
